import { boolean, intersect, partial, string, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const Request = intersect(
	struct({
		/** Layer the openings are cut OUT OF. Keeps its id, name and colour. */
		baseLayerId: string,
		/**
		 * Layers whose closed rings are removed from the base. Order is irrelevant:
		 * overlapping subtrahends are unioned by the clipper, so shared area is only
		 * ever removed once.
		 */
		subtrahendLayerIds: iotsUtils.NonEmptyArray(string),
	})
)(
	partial({
		/** Compute and report the outcome without persisting anything. */
		dryRun: boolean,
	})
);
